import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=97c6f670&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=ts"
export * from "./DataTable.vue?vue&type=script&lang=ts"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=97c6f670&prod&lang=scss&scoped=true"
import style1 from "./DataTable.vue?vue&type=style&index=1&id=97c6f670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c6f670",
  null
  
)

export default component.exports